
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19660.018 -15186.255 12.57 12.509"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{staticClass:"a",attrs:{"opacity":".54"}},[_c('path',{staticClass:"b",attrs:{"d":"M-19653.687-15185.505a5.5 5.5 0 0 1 2.484 10.4","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.5"}}),_c('path',{staticClass:"c",attrs:{"d":"M-19648.78-15174.495l-3.005.491c-.123.031-.215-.092-.215-.215l.491-3.005a.174.174 0 0 1 .307-.092l2.515 2.515c.122.122.06.306-.093.306z","fill":"#444"}}),_c('path',{staticClass:"b",attrs:{"d":"M-19653.779-15174.491a5.5 5.5 0 0 1-2.484-10.4","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.5"}}),_c('path',{staticClass:"c",attrs:{"d":"M-19658.685-15185.504l3.005-.491c.123-.031.215.092.215.215l-.491 3.005a.174.174 0 0 1-.307.092l-2.547-2.514a.188.188 0 0 1 .125-.307z","fill":"#444"}})])])
          )
        }
      }
    